import { render } from "./LegalNotice.vue?vue&type=template&id=dcbce45e&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=js"
export * from "./LegalNotice.vue?vue&type=script&lang=js"

import "./LegalNotice.vue?vue&type=style&index=0&id=dcbce45e&scoped=true&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcbce45e"]])

export default __exports__